import { StrictMode, startTransition } from "react";
import { hydrateRoot } from "react-dom/client";
import { HydratedRouter } from "react-router/dom";
import { initializePostHog, PosthogInit } from "./components/posthog";

function installWordAddinHistoryShim() {
  if (!window.location.pathname.startsWith("/word/")) return;

  const historyState = window.history.state ?? null;

  for (const method of ["replaceState", "pushState"] as const) {
    if (typeof window.history[method] === "function") continue;

    try {
      Object.defineProperty(window.history, method, {
        configurable: true,
        value: () => {},
        writable: true,
      });
    } catch {
      try {
        window.history[method] = () => {};
      } catch {}
    }
  }

  try {
    Object.defineProperty(window.history, "state", {
      configurable: true,
      get: () => historyState,
    });
  } catch {}
}

installWordAddinHistoryShim();
initializePostHog();

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <HydratedRouter />
      <PosthogInit />
    </StrictMode>
  );
});
